<section class="divider">
	<div
		class="px-6 py-12 overflow-hidden text-center border border-gray-200 rounded-lg bg-gray-50"
	>
		<uc-telephone-svg
			class="block mx-auto mb-4 w-fit"
			[customStyles]="'w-8 h-8 text-gray-500'"
		/>
		<span class="text-xl font-bold leading-6">Contact our sales team</span>
		<p class="max-w-4xl px-6 m-auto mt-3 text-gray-500">
			Whether you’re looking to boost brand awareness, drive targeted traffic,
			increase student acquisitions, or generate high-quality leads, Uni Compare is
			here to help you make it happen. Our team knows exactly how to connect your
			university with the students who matter most. Want to find out how? We’d love
			to show you what we can do.
			<br />
			<br />
			Reach out now at
			<a
				href="mailto:sales@universitycompare.com?subject=Sales Inquiry"
				class="blue-link-underline"
				>sales&#64;universitycompare.com</a
			>
			– let’s talk about what Uni Compare can do for you!
		</p>
	</div>
</section>
